/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/096-box-remove': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 1H3L0 4v10.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V4l-3-3zm-3 9v3H6v-3H3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1H2.414z"/>'
  }
})
